import {Box, Button, Container, Typography, useMediaQuery} from "@mui/material";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";

export function Pricelist() {
    const minWidth = useMediaQuery("(min-width:1200px)");

    const onDownload = () => {
        const link = document.createElement("a");
        link.download = `prijslijst.pdf`;
        link.href = "prijslijst.pdf";
        link.click();
    };
    return (
        <>
            <Container maxWidth="md">
                <Box sx={{display: "flex", mt: 10, alignItems: "center", flexDirection: "column"}}>
                    <Typography variant="h3" color={"#E39B3B"} sx={{
                        mb: 2,
                        fontFamily: 'Barlow',
                        fontSize: '40px', fontStyle: 'normal', fontWeight: '700', textTransform: "uppercase"
                    }}>Prijzen & info</Typography>
                    <Typography variant="h6" color={"#E39B3B"}
                                sx={{fontFamily: 'Barlow', fontStyle: 'normal', fontWeight: '500', mb: 1}}>Belangrijke info</Typography>
                    <Typography sx={{
                        fontFamily: 'Barlow',
                        fontStyle: 'bold',
                        fontWeight: '700',
                        textAlign: "center",
                        mb: 2
                    }}>Puppygewenning is gratis tot 6 maanden.
                    </Typography>
                    <Typography sx={{
                        fontFamily: 'Barlow',
                        fontStyle: 'bold',
                        fontWeight: '700',
                        textAlign: "center",
                        mb: 2
                    }}>Annulaties dienen 48 uur op voorhand te gebeuren, anders ben ik genoodzaakt om de trimbeurt gedeeltelijk aan te rekenen.
                    </Typography>
                    <Typography sx={{
                        fontFamily: 'Barlow',
                        fontStyle: 'bold',
                        fontWeight: '700',
                        textAlign: "center",
                        mb: 2
                    }}>U kan in het salon steeds betalen met cash (gepast), payconiq of de bankapp.
                    </Typography>
                    <Typography variant="h6" color={"#E39B3B"}
                                sx={{fontFamily: 'Barlow', fontStyle: 'normal', fontWeight: '500', mb: 1}}>Richtprijzen
                        trimbeurt</Typography>
                    <Typography sx={{
                        fontFamily: 'Barlow',
                        fontStyle: 'normal',
                        fontWeight: '400',
                        textAlign: "center",
                        fontSize: "18px",
                        mb: 2
                    }}>
                        Trimmen kan volgens de rasstandaard of jouw voorkeur. De vermelde prijzen zijn richtprijzen en
                        afhankelijk van de vachtconditie en het gedrag van je hond.

                        Inbegrepen in de basisprijs: wassen, drogen, borstelen, ontwollen, knippen of scheren
                        (afhankelijk
                        van het vachttype), nagels knippen, voetzooltjes bijwerken, oren en ogen reinigen.

                        Er kunnen toeslagen gelden bij o.a. klitten, parasieten of onhandelbaar gedrag.
                    </Typography>
                </Box>
            </Container>
            <Container sx={{mt: 3}} maxWidth="lg">
                {minWidth && <embed
                    src="https://trimsalonminimax.s3.eu-west-2.amazonaws.com/assets/prijslijst.pdf"
                    width={"100%"}
                    height={"650px"}
                />}
                {!minWidth && <Box sx={{display: 'flex', flexWrap: 'wrap', justifyContent: "center"}}>
                    <Typography sx={{fontFamily: "Barlow", color: "#D3B89B", fontWeight: "bold", fontSize: "20px", m: 2}}>Download de
                        prijslijst hier: </Typography>
                    <Button startIcon={<CloudDownloadIcon/>} onClick={onDownload} sx={{ml: 3, mr: 3, backgroundColor: "#D3B89B", fontFamily: 'Barlow', fontSize: '18px', fontStyle: 'normal', fontWeight: '500'}}
                            variant="contained">Download prijslijst</Button>
                </Box>}
            </Container>
        </>
    )
}